import { UserInfoListDto } from "../../services";
import { PermissionManager } from "./PermissionManager";

type props = {
  user: UserInfoListDto | null;
  children: JSX.Element;
};

export function RequireUploadContentPermission({ user, children }: props) {
  return <>{PermissionManager.canUploadContent(user) ? children : <></>}</>;
}
